module.exports = __webpack_public_path__ + "static/media/Home Page_website-31.7f4040ae.png";